import React, { useEffect, useState } from 'react'
import { Button, Modal, ModalBody, ModalHeader, Table } from 'reactstrap';
import httpService from '../../../services/http.service';
import WarningMessage from '../../common/warnMsg';
import SuccessMessage from '../../common/successMsg';
import ErrorMessage from '../../common/errorMsg';
import { useHistory } from 'react-router-dom';
import Loader from './Loader';

const UserInfo = ({ setRefresh }) => {
    const [users, setUsers] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const history = useHistory()
    const [openDialog, setOpenDialog] = useState({
        name: "",
        type: "",
        id: ""
    })
    const getAllAssociatedUser = async () => {
        try {

            const { data } = await httpService.get("/property-manager/get-all-associate-users")

            setUsers(data.userData.users)

        } catch (error) {
            console.log(error)
            if (error.response.status === 401) {
                history.push("/")
                ErrorMessage(error.response.data.message)
                localStorage.clear()
            }
        } finally {
            setIsLoading(false)
        }
    }

    const handleDeleteUser = async () => {
        try {

            const dataObj = {
                userId: openDialog.id
            }

            const { data } = await httpService.CreateUpdate("property-manager/user-delete", dataObj)

            if (data.ack === "0") {
                return WarningMessage(data.message)
            }
            if (data.ack === "1") {
                SuccessMessage(data.message)
            }

            setOpenDialog({
                name: "",
                type: "",
                id: ""
            })

            getAllAssociatedUser()
            setRefresh((prev) => prev + 1)
        } catch (error) {
            console.log(error, "error")
            WarningMessage("Something went wrong")
        }
    }

    useEffect(() => {
        getAllAssociatedUser()
    }, [])
    return (
        <>
            {isLoading ? <Loader /> : <>
                {(users.length === 0 && isLoading === false) && <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", fontSize: 18 }}>No user found</div>}

                {(users.length > 0 && isLoading === false) && <Table className="table-inner" style={{ border: "1px solid #ddd" }}>
                    <thead className="bg-header" style={{ position: 'sticky', top: '0', zIndex: '5' }}>
                        <tr>
                            <th>Account Name</th>
                            <th>Account No.</th>
                            <th>Email</th>
                            <th>Mobile No.</th>
                            {/* <th>Update</th> */}
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody className="font12"
                    >
                        {users && users.map((user, index) => {

                            return (
                                <>
                                    <tr
                                        key={index.toString() + index.toString()}
                                        className="pointer"
                                    >
                                        <td>{user.customerId}</td>
                                        <td>
                                            {user.accountNo}
                                        </td>
                                        <td >
                                            {user.email}
                                        </td>
                                        <td >
                                            {user.mobileNo}
                                        </td>
                                        {/* <td>
                                        <button
                                            style={{
                                                transform: "scale(0.8)",
                                            }}
                                            className="btn btn-sm btn-secondary"
                                        // onClick={() => {
                                        //     setOpenDialog({
                                        //         name: 'Unassign User',
                                        //         type: 'unassignProperty',
                                        //         id: user._id
                                        //     })
                                        // }}
                                        >
                                            <i className="trash icon me-0"></i>
                                        </button>{" "}
                                    </td> */}
                                        <td>
                                            <button
                                                style={{
                                                    transform: "scale(0.8)",
                                                }}
                                                className="btn btn-sm btn-danger"
                                                onClick={() => {
                                                    setOpenDialog({
                                                        name: 'Delete Confirm',
                                                        type: 'deleteConfirm',
                                                        id: user._id
                                                    })
                                                }}
                                            >
                                                <i className="trash icon me-0"></i>
                                            </button>{" "}
                                        </td>
                                    </tr>
                                </>
                            )
                        })
                        }
                    </tbody>
                </Table>}
            </>}



            <Modal isOpen={openDialog.type === "deleteConfirm"} centered>
                <ModalHeader toggle={() => setOpenDialog({
                    name: '',
                    type: '',
                    id: ''
                })}>Confirm Delete</ModalHeader>

                <ModalBody>
                    <p style={{ fontSize: "16px", marginBottom: "20px" }}>
                        Are you sure you want to delete this User?
                        You won't be able to revert this!.
                    </p>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                        <Button color="secondary" onClick={() => setOpenDialog({
                            name: '',
                            type: '',
                            id: ''
                        })}>
                            Cancel
                        </Button>

                        <Button color="danger" onClick={() => handleDeleteUser()}>
                            Delete
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}

export default UserInfo